module.exports = __webpack_public_path__ + "static/media/NFLAnalysisApp_1920x1080.2676961c.png";